import { json, LoaderFunctionArgs, MetaFunction } from "@remix-run/node";
import HeaderBlock from "~/modules/pageBlocks/components/blocks/marketing/header/HeaderBlock";
import FooterBlock from "~/modules/pageBlocks/components/blocks/marketing/footer/FooterBlock";
import { MetaTagsDto } from "~/application/dtos/seo/MetaTagsDto";
import { getDefaultSiteTags } from "~/modules/pageBlocks/utils/defaultSeoMetaTags";
import { getLinkTags } from "~/modules/pageBlocks/services/.server/pagesService";
import { getTranslations } from "~/locale/i18next.server";
import { useTranslation } from "react-i18next";
import NewsletterBlock from "~/modules/pageBlocks/components/blocks/marketing/newsletter/NewsletterBlock";
import AllDemos from "~/modules/datalang/components/demos/AllDemos";

export const meta: MetaFunction<typeof loader> = ({ data }) => data?.metatags || [];

type LoaderData = {
  metatags: MetaTagsDto;
};
export let loader = async ({ request }: LoaderFunctionArgs) => {
  const { t } = await getTranslations(request);
  const data: LoaderData = {
    metatags: [
      { title: `${t("datalang.demos.all.title")} | ${getDefaultSiteTags({ t }).title}` },
      { description: t("datalang.demos.all.description") },
      ...getLinkTags(request),
    ],
  };
  return json(data);
};

export default function () {
  const { t } = useTranslation();
  return (
    <div>
      <div>
        <HeaderBlock />
        <div className="sm:align-center mx-auto px-4 py-12 sm:flex sm:flex-col sm:px-6 sm:py-6 lg:px-8">
          <div>
            <div className="mb-10 text-center">
              <h1 className="text-3xl font-extrabold tracking-tight sm:text-4xl">{t("datalang.demos.all.title")}</h1>
              <h2 className="text-muted-foreground mt-4 text-lg  leading-6">{t("datalang.demos.all.description")}</h2>
            </div>
            <div className="container mx-auto mt-10 max-w-5xl space-y-4 px-5">
              <AllDemos showPremium={true} withDescriptions={true} withFeedback={true} />
            </div>
          </div>
        </div>
        {/* <NewsletterBlock
          item={{
            style: "simple",
            headline: t("front.newsletter.title"),
            subheadline: t("front.newsletter.headline"),
          }}
        /> */}
        <FooterBlock />
      </div>
    </div>
  );
}
